import { useCallback, useMemo } from "react";
import { getPlantDropdownLabel } from "../../services/plantDisplay";
import { useGetPlantsQuery, useLazyGetPlantsQuery } from "./plantApi";

export const buildPlantOptions = (plants = []) =>
  plants
    .filter((plant) => plant?.plant_id)
    .map((plant) => ({
      value: plant.plant_id,
      label: getPlantDropdownLabel(plant, plant.plant_id),
    }));

export const usePlantOptions = () => {
  const { data, isFetching } = useGetPlantsQuery({ page: 1, limit: 1000 });
  const options = useMemo(
    () => buildPlantOptions(data?.data || []),
    [data?.data]
  );

  return { options, isFetching };
};

export const useLazyPlantOptions = () => {
  const [loadPlants, { data, isFetching }] = useLazyGetPlantsQuery();
  const options = useMemo(
    () => buildPlantOptions(data?.data || []),
    [data?.data]
  );

  const ensurePlantOptions = useCallback(() => {
    if (!data && !isFetching) {
      loadPlants({ page: 1, limit: 1000 });
    }
  }, [data, isFetching, loadPlants]);

  return {
    options,
    isFetching,
    loadOptions: ensurePlantOptions,
  };
};
